 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"eb8ecaa16fa12774cc8fd5edd8500357da68de9b","1":"2137eac67d5828336beb95477a0de354d1b8e086","2":"9157f78a433ef1ca9d16210536e9031711d0b66e","3":"styles","4":"1fd1bc7b7ac8d6ca7f0bfb8d3bf9a0d8a49bfe20","5":"3a7ac873a0cf38d4983a29bf45b81d90864828a0","6":"c03d62f9a03b9626e9dc06e91e24167e346466d2","7":"40fd877f2cedd622389f01714d4dcb11b72fc9a1","8":"90c72939c2472e06260b9f4dc118d16767dc57ac","9":"framework","10":"487f2abd0ffcfcc10a849c254c810c473567d611","11":"597649971daaefb9579dc15f4283a65118751b41","12":"e226a718fa45f98299c8f7bfef927fde17b67910","13":"f8e65d95b74889b22afc42d28197cbc597a29cd3","16":"component---themes-gatsby-theme-wpgrapql-src-pages-1031-exchanges-js","17":"component---themes-gatsby-theme-wpgrapql-src-pages-404-js","18":"component---themes-gatsby-theme-wpgrapql-src-pages-about-js","19":"component---themes-gatsby-theme-wpgrapql-src-pages-contact-js","20":"component---themes-gatsby-theme-wpgrapql-src-pages-dst-js","21":"component---themes-gatsby-theme-wpgrapql-src-pages-home-with-loader-js","22":"component---themes-gatsby-theme-wpgrapql-src-pages-index-js","23":"component---themes-gatsby-theme-wpgrapql-src-pages-investors-js","24":"component---themes-gatsby-theme-wpgrapql-src-pages-news-js","25":"component---themes-gatsby-theme-wpgrapql-src-pages-old-news-js","26":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-chart-animation-js","27":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-e-animation-js","28":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-logo-animation-js","29":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-scrolltest-js","30":"component---themes-gatsby-theme-wpgrapql-src-pages-portfolio-js","31":"component---themes-gatsby-theme-wpgrapql-src-pages-private-client-js","32":"component---themes-gatsby-theme-wpgrapql-src-pages-strategy-js","33":"component---themes-gatsby-theme-wpgrapql-src-pages-value-add-funds-js","34":"component---themes-gatsby-theme-wpgrapql-src-templates-portfolio-index-js"}[chunkId]||chunkId) + "-" + {"0":"de272173840814c14b87","1":"a3d5056f8c2ec1d2fc55","2":"f059982139f7a1beb61f","3":"365f87b8b168dadf8c1d","4":"f9aa273b7b0b064b1765","5":"5e03dbc803164180b444","6":"4277f027a26c3f3b3840","7":"0003578ce20cdc27f153","8":"2f32a8b5c48907bb8404","9":"3f20bd1890eef89b34fa","10":"7f2952387d4d29fd1b21","11":"8e82f833d6767227b6a4","12":"c1aff3faae934b97e826","13":"f414f0987b1f343cc219","16":"7bf5ece7d55dca2e883e","17":"c8c03bee0671782306a1","18":"f9b4b3c88841c96c7992","19":"df9cfd515213ebacc260","20":"7c2532cf9871b7451c95","21":"c54758852e15f9c67663","22":"7e82ca14455b865b6e89","23":"f6d7b33bc733ac1f8470","24":"41fd6f58fc6cc73ee0ad","25":"747551ed59e51bda5a30","26":"82f1dd63a8cac60c6351","27":"4226a221d94f7d405bf6","28":"256dc1168046c4f5ce6a","29":"5c2f2636a2a7c820dc4d","30":"93038dba72673fa1c5cf","31":"aaf145366f475b02c562","32":"332fdf8202467164dd8b","33":"de3b3baaeec090a99a64","34":"5a4ad9557963d5e90511"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"eb8ecaa16fa12774cc8fd5edd8500357da68de9b","1":"2137eac67d5828336beb95477a0de354d1b8e086","2":"9157f78a433ef1ca9d16210536e9031711d0b66e","3":"styles","4":"1fd1bc7b7ac8d6ca7f0bfb8d3bf9a0d8a49bfe20","5":"3a7ac873a0cf38d4983a29bf45b81d90864828a0","6":"c03d62f9a03b9626e9dc06e91e24167e346466d2","7":"40fd877f2cedd622389f01714d4dcb11b72fc9a1","8":"90c72939c2472e06260b9f4dc118d16767dc57ac","9":"framework","10":"487f2abd0ffcfcc10a849c254c810c473567d611","11":"597649971daaefb9579dc15f4283a65118751b41","12":"e226a718fa45f98299c8f7bfef927fde17b67910","13":"f8e65d95b74889b22afc42d28197cbc597a29cd3","16":"component---themes-gatsby-theme-wpgrapql-src-pages-1031-exchanges-js","17":"component---themes-gatsby-theme-wpgrapql-src-pages-404-js","18":"component---themes-gatsby-theme-wpgrapql-src-pages-about-js","19":"component---themes-gatsby-theme-wpgrapql-src-pages-contact-js","20":"component---themes-gatsby-theme-wpgrapql-src-pages-dst-js","21":"component---themes-gatsby-theme-wpgrapql-src-pages-home-with-loader-js","22":"component---themes-gatsby-theme-wpgrapql-src-pages-index-js","23":"component---themes-gatsby-theme-wpgrapql-src-pages-investors-js","24":"component---themes-gatsby-theme-wpgrapql-src-pages-news-js","25":"component---themes-gatsby-theme-wpgrapql-src-pages-old-news-js","26":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-chart-animation-js","27":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-e-animation-js","28":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-logo-animation-js","29":"component---themes-gatsby-theme-wpgrapql-src-pages-playground-scrolltest-js","30":"component---themes-gatsby-theme-wpgrapql-src-pages-portfolio-js","31":"component---themes-gatsby-theme-wpgrapql-src-pages-private-client-js","32":"component---themes-gatsby-theme-wpgrapql-src-pages-strategy-js","33":"component---themes-gatsby-theme-wpgrapql-src-pages-value-add-funds-js","34":"component---themes-gatsby-theme-wpgrapql-src-templates-portfolio-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"1aa51850edc4fd17f984","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
